import CustomNavLink from '../CustomNavLink/CustomNavLink';

interface INavigation {
  openVideoModal?: any;
  props: any;
}
export default function Navigation({ openVideoModal, props }: INavigation) {
  return (
    <div
      className={
        'grid grid-cols-1 gap-4 max-tablet:grid-cols-4 max-tablet:gap-6 max-tablet:place-items-center max-tablet:py-0.5'
      }
    >
      <CustomNavLink
        variant={'howToUse'}
        label={'How to use RumbleRank?'}
        onClick={openVideoModal}
      />
      <CustomNavLink
        variant={'list'}
        label={'Manage your Rumbles'}
        tag={'NavLink'}
        to={'/dashboard'}
      />
      <CustomNavLink
        variant={'create'}
        label={'Create new Rumble'}
        tag={'NavLink'}
        to={'/create'}
      />
      <CustomNavLink
        variant={'setup'}
        label={'Setup Rumble branding'}
        tag={'NavLink'}
        disabled={props.user?.subscriptionTier === 'Free'}
        to={'/SetupRumbleBranding'}
      />
    </div>
  );
}
